/**
 * Account-level gate for the minified campaign detail page — the page the
 * Campaign Grid opens (`/campaign/v3/start?campaign=…&from=grid`).
 *
 * Opt-in per account via the `campaign-grid-minified` account setting
 * (boolean-string convention, same as `hide-upload-creatives`). When 'true', a
 * launched campaign opened from the grid shows only its campaign configuration,
 * delivered stats and creatives, plus the Sidekick agent. Absent or any other
 * value keeps the full review pane, so existing accounts are unaffected.
 */
export const CAMPAIGN_GRID_MINIFIED_KEY = 'campaign-grid-minified';

export function isCampaignGridMinified(accountSettings) {
  return accountSettings?.[CAMPAIGN_GRID_MINIFIED_KEY] === 'true';
}
